import * as React from "react";
import PropTypes from "prop-types";
const SvgSportsHandcycleNormalLarge = React.forwardRef(
  ({ color = "currentColor", size = 48, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 48 48"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M26 22c.57 0 1.103-.159 1.556-.435l6.302 3.456L29.878 29h-7.906a2.5 2.5 0 01-2.236-1.382l-5.565-11.13-2.683 1.341 5.544 11.088a29.598 29.598 0 01-4.089-.552 6.5 6.5 0 10-1.095 2.831c2.027.463 4.566.803 7.652.803h2v-.02c.156.014.314.021.472.021H30.5a1.5 1.5 0 001.06-.44l3.467-3.466a6.5 6.5 0 101.648-4.95L29 18.934A3 3 0 1026 22zM3 27.5a3.5 3.5 0 117 0 3.5 3.5 0 01-7 0zM41.5 24a3.5 3.5 0 110 7 3.5 3.5 0 010-7z"
        fill=""
      />
    </svg>
  )
);
SvgSportsHandcycleNormalLarge.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgSportsHandcycleNormalLarge;
